export const IMPORTED_TOURNAMENT_GET_SUMMARY_REQUEST = 'IMPORTED_TOURNAMENT:GET_SUMMARY_REQUEST';
export const IMPORTED_TOURNAMENT_GET_SUMMARY_SUCCESS = 'IMPORTED_TOURNAMENT:GET_SUMMARY_SUCCESS';
export const IMPORTED_TOURNAMENT_GET_SUMMARY_FAILURE = 'IMPORTED_TOURNAMENT:GET_SUMMARY_FAILURE';

export const IMPORTED_TOURNAMENT_GET_PLAYERS_REQUEST = 'IMPORTED_TOURNAMENT:GET_PLAYERS_REQUEST';
export const IMPORTED_TOURNAMENT_GET_PLAYERS_SUCCESS = 'IMPORTED_TOURNAMENT:GET_PLAYERS_SUCCESS';
export const IMPORTED_TOURNAMENT_GET_PLAYERS_FAILURE = 'IMPORTED_TOURNAMENT:GET_PLAYERS_FAILURE';

export const IMPORTED_TOURNAMENT_GET_DRAWS_REQUEST = 'IMPORTED_TOURNAMENT:GET_DRAWS_REQUEST';
export const IMPORTED_TOURNAMENT_GET_DRAWS_SUCCESS = 'IMPORTED_TOURNAMENT:GET_DRAWS_SUCCESS';
export const IMPORTED_TOURNAMENT_GET_DRAWS_FAILURE = 'IMPORTED_TOURNAMENT:GET_DRAWS_FAILURE';

export const IMPORTED_TOURNAMENT_GET_FILTERS_REQUEST = 'IMPORTED_TOURNAMENT:GET_FILTERS_REQUEST';
export const IMPORTED_TOURNAMENT_GET_FILTERS_SUCCESS = 'IMPORTED_TOURNAMENT:GET_FILTERS_SUCCESS';
export const IMPORTED_TOURNAMENT_GET_FILTERS_FAILURE = 'IMPORTED_TOURNAMENT:GET_FILTERS_FAILURE';

export const IMPORTED_TOURNAMENT_GET_RESULTS_REQUEST = 'IMPORTED_TOURNAMENT:GET_RESULTS_REQUEST';
export const IMPORTED_TOURNAMENT_GET_RESULTS_SUCCESS = 'IMPORTED_TOURNAMENT:GET_RESULTS_SUCCESS';
export const IMPORTED_TOURNAMENT_GET_RESULTS_FAILURE = 'IMPORTED_TOURNAMENT:GET_RESULTS_FAILURE';
